import { type FC, type PropsWithChildren, useEffect } from 'react';
import useMeasure from 'react-use-measure';
import cn from 'classnames';

import { setCssVar } from '@/common/lib/cssVar';

import css from './styles.module.scss';

const DesktopContainer: FC<PropsWithChildren> = ({ children }) => {
  const [ref, measure] = useMeasure();

  useEffect(() => {
    setCssVar('--desktop-container-offset-left', `${measure.left}px`);
    setCssVar('--desktop-container-content-width', `${measure.width}px`);
  }, [measure]);

  return (
    <div className={cn(css.desktop)}>
      <div ref={ref} className={cn(css.desktopInner)}>
        {measure.width ? children : null}
      </div>
    </div>
  );
};

export { DesktopContainer };
